module.exports = __webpack_public_path__ + "static/media/card-recognized.f10968f4.svg";